module.exports = "../study/imgs/maps/Nagano/S8/Ecosystem/PinusPumila/Nagano_PinusPumila_MIROC5_RCP26_Mid.png";